import React, { ReactElement } from 'react';
import Table from '../../../components/table/table.component';
import TableBody from '../../../components/table-body/table-body.component';
import TableRow from '../../../components/table-row/table-row.component';
import TableCell from '../../../components/table-cell/table-cell.component';
import SinglePageTab from '../../app/common/single-page-tab/single-page-tab.component';

const AssetManagementFeeInformation: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    formError,
    assetData,
    onCancelForm,
    onSubmitForm,
  } = props;

  const isEmpty: boolean = isEditMode || (!assetData.yardiManagementFeePercent && !assetData.yardiCurrentManagementFee);

  return (
    <SinglePageTab
      isSaving={isSaving}
      isEmpty={isEmpty}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      {
        !isEmpty && (
          <Table>
            <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
              {
                !isEditMode && assetData.yardiManagementFeePercent && (
                  <TableRow>
                    <TableCell>
                      Management Fee Percent (Yardi)
                    </TableCell>
                    <TableCell>
                      {assetData.yardiManagementFeePercent}
                    </TableCell>
                  </TableRow>
                )
              }
              {
                !isEditMode && assetData.yardiCurrentManagementFee && (
                  <TableRow>
                    <TableCell>
                      Current Management Fee (Yardi)
                    </TableCell>
                    <TableCell>
                      {assetData.yardiCurrentManagementFee}
                    </TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        )
      }
    </SinglePageTab>
  );
});

export default AssetManagementFeeInformation;
